export { default } from "./TextareaAutosize.js";